<h1 class="card-title table-card-title">Quiz Sessions</h1>
<div class="table-card" *ngIf="tableReady">
    <table>
        <tr>
            <th *ngFor="let column of displayedColumns" class="font-title">
                {{column | translate}}
            </th>
        </tr>
        <tr *ngFor="let row of pageOfItems">
            <td class="arabic-story-name">
                {{row.storybook_name}}
            </td>
            <td *ngIf="row.studentUsername" class="font-title">
                {{row.studentUsername}}
            </td>
            <td *ngIf="!row.studentUsername" class="font-title">
                Teacher
            </td>
            <td class="font-title">
                {{row.quizScore}}
            </td>
            <td class="font-title"> 
                {{row.createdDate | date}}
            </td>
        </tr>
    </table>
    <div class="pag-card font-title">
        <jw-pagination [items]="quizSessions" (changePage)="onChangePage($event)"></jw-pagination>
    </div>
</div>
